export const Currencies: Record<string, string> = {
  EUR: 'Euro',
  CHF: 'Swiss Franks',
  CZK: 'Czech koruna',
  SEK: 'Swedish krona',
  GBP: 'British pound',
  DKK: 'Danish krone',
  HRK: 'Croatian kuna',
  PLN: 'Polish Zloty',
  HUF: 'Hungarian forint',
  NOK: 'Norwegian krone',
  BGN: 'Bulgarian lev',
  RON: 'Romanian leu',
  RSD: 'Serbian dinar',
  USD: 'USA dollar',
  ALL: 'Albanian lek',
  BAM: 'Bosnia and Herzegovina convertible mark',
  UAH: 'Ukrainian hryvnia',
  MKD: 'Macedonian denar',
  RUB: 'Russian ruble',
  INR: 'Indian rupees',
  TRY: 'Turkish lira',
  BRL: 'Brazil Real',
  CAD: 'Canadian Dollar',
  MXN: 'Mexican Peso',
  CLP: 'Chilean peso',
  AUD: 'Australian Dollar',
  PEN: 'Peruvian Sol',
};
